export default __webpack_public_path__ + "static/controllers_m-7a3ebe486dd8f88ccbb0946d1e6235e0.png";